export const stateName = 'privacyPolicy';